import { render, staticRenderFns } from "./TRadioButton.vue?vue&type=template&id=5da08a60&scoped=true&"
import script from "./TRadioButton.vue?vue&type=script&lang=js&"
export * from "./TRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./TRadioButton.vue?vue&type=style&index=0&id=5da08a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da08a60",
  null
  
)

/* custom blocks */
import block0 from "./TRadioButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports